import Controller from "@ember/controller"
import { inject as service } from "@ember/service"
import hasMany from "../../../helpers/has-many"

export default class ActionController extends Controller {
  @service
  rpc

  @service("ember-store")
  store

  @hasMany("model", "patch", "patches")
  patches
}
